import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Colors } from 'advenio-components'
import MenuButton from './MenuButton'

const Container = styled.div`
  position: ${props => props.isMenuOpen ? 'fixed' : 'relative'};
  z-index: 100;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 48px;
  width: 100%;
  padding: 8px 0;
  background-color: ${Colors.advenioRed};

  @media (min-width: 768px) {
    position: absolute;
    top:0;
    margin-left: 220px;
    padding: 8px 0 8px 8px;
    width: calc(100% - 228px);
  }

  @media (min-width: 1024px) {
    position: absolute;
    top:0;
    margin-left: 280px;
    padding: 8px 0 8px 8px;
    width: calc(100% - 288px);
  }
`
const Title = styled.span`
  font-size: 30px;
  color: white;
`
const Content = styled.div`
  position: fixed;
  bottom: ${props => props.isMenuOpen ? '0' : '-100%'};
  left: 0;
  height: calc(100% - 64px);
  width: 100%;
  background-color: white;
  -webkit-transition: bottom 250ms; /* Safari */
  transition: bottom 250ms;

  @media (min-width: 768px) {
    position: fixed;
    top:0;
    left: 0;
    background-color: ${Colors.blueText};
    width: 220px;
    height: 100%;
  }

  @media (min-width: 1024px) {
    position: fixed;
    top:0;
    left: 0;
    background-color: ${Colors.blueText};
    width: 280px;
    height: 100%;
  }
`
const HomePageLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-decoration: none;

  img {
    margin: 8px;
  }

  &:active{
    color: white;
  }
`

class Navbar extends Component {
  state = {
    isMenuOpen: false,
    iconType: 'open',
  }

  componentWillUnmount = () => {
    document.querySelector('body').style.height = 'auto'
    document.querySelector('body').style.overflow = 'auto'
    document.querySelector('#root').style.height = 'auto'
    document.querySelector('#root').style.overflow = 'auto'
  }

  toggleOpen = () => {
    const { isMenuOpen } = this.state
    const iconType = !isMenuOpen ? 'close' : 'open'

    if (!isMenuOpen) {
      document.querySelector('body').style.height = '600px'
      document.querySelector('body').style.overflow = 'hidden'
      document.querySelector('#root').style.height = '600px'
      document.querySelector('#root').style.overflow = 'hidden'
    } else {
      document.querySelector('body').style.height = 'auto'
      document.querySelector('body').style.overflow = 'auto'
      document.querySelector('#root').style.height = 'auto'
      document.querySelector('#root').style.overflow = 'auto'
    }

    this.setState({ isMenuOpen: !isMenuOpen, iconType })
  }

  close = () => {
    const iconType = 'open'
    document.querySelector('body').style.height = 'auto'
    document.querySelector('body').style.overflow = 'auto'
    document.querySelector('#root').style.height = 'auto'
    document.querySelector('#root').style.overflow = 'auto'
    this.setState({ isMenuOpen: false, iconType })
  }

  render() {
    const { iconType, isMenuOpen } = this.state

    return (
      <Container isMenuOpen={isMenuOpen}>
        <MenuButton
          icon={iconType}
          onClick={this.toggleOpen}
        />
        <Title>
          <HomePageLink to="/parent">
            <img src="/assets/Advenio.svg" alt="logo" />
            MiAdvenio
          </HomePageLink>
        </Title>
        <Content isMenuOpen={isMenuOpen}>
          {this.props.children}
        </Content>
      </Container>
    )
  }
}

Navbar.propTypes = {
  /** The content to be displayed inside the nav bar */
  children: PropTypes.node.isRequired,
}

export default Navbar



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/Navbar/index.jsx